"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchKeyValueInObj = void 0;
const switchKeyValueInObj = (obj) => {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [value, key]));
};
exports.switchKeyValueInObj = switchKeyValueInObj;
